export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#182022] py-14">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 text-center">
      <p className="font-display text-xl font-semibold text-white">
        Brown &amp; Associates, LLC
      </p>
      <p className="mt-2 text-sm uppercase tracking-[0.18em] text-[#20C9C3]">
        Bookkeeping and Tax Services
      </p>
      <a
        href="https://brownandassociatesllc.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-website-link"
        className="mt-3 inline-block text-sm text-white/60 hover:text-[#C5A253] transition-colors duration-300"
      >
        brownandassociatesllc.com
      </a>
      <div className="mx-auto mt-8 h-px w-24 bg-[#C5A253]/40" />
      <p className="mt-8 text-xs tracking-wide text-white/45" data-testid="footer-copyright">
        Copyright 2026 Joede Brown. All Rights Reserved.
      </p>
    </div>
  </footer>
);
